import { Injectable } from '@angular/core';
import { PrimeNG } from 'primeng/config';
@Injectable({
  providedIn: 'root',
})
export class TranslateService {
  constructor(private config: PrimeNG) {}

  setPrimeNGTranslations() {
    this.config.setTranslation({
      // --- Calendario e Date ---
      dayNames: [
        $localize`:@@primeng.day.sunday:Domenica`,
        $localize`:@@primeng.day.monday:Lunedì`,
        $localize`:@@primeng.day.tuesday:Martedì`,
        $localize`:@@primeng.day.wednesday:Mercoledì`,
        $localize`:@@primeng.day.thursday:Giovedì`,
        $localize`:@@primeng.day.friday:Venerdì`,
        $localize`:@@primeng.day.saturday:Sabato`,
      ],
      dayNamesShort: [
        $localize`:@@primeng.dayShort.sun:Dom`,
        $localize`:@@primeng.dayShort.mon:Lun`,
        $localize`:@@primeng.dayShort.tue:Mar`,
        $localize`:@@primeng.dayShort.wed:Mer`,
        $localize`:@@primeng.dayShort.thu:Gio`,
        $localize`:@@primeng.dayShort.fri:Ven`,
        $localize`:@@primeng.dayShort.sat:Sab`,
      ],
      dayNamesMin: [
        $localize`:@@primeng.dayMin.sun:Dom`,
        $localize`:@@primeng.dayMin.mon:Lun`,
        $localize`:@@primeng.dayMin.tue:Mar`,
        $localize`:@@primeng.dayMin.wed:Mer`,
        $localize`:@@primeng.dayMin.thu:Gio`,
        $localize`:@@primeng.dayMin.fri:Ven`,
        $localize`:@@primeng.dayMin.sat:Sab`,
      ],
      monthNames: [
        $localize`:@@primeng.month.jan:Gennaio`,
        $localize`:@@primeng.month.feb:Febbraio`,
        $localize`:@@primeng.month.mar:Marzo`,
        $localize`:@@primeng.month.apr:Aprile`,
        $localize`:@@primeng.month.may:Maggio`,
        $localize`:@@primeng.month.jun:Giugno`,
        $localize`:@@primeng.month.jul:Luglio`,
        $localize`:@@primeng.month.aug:Agosto`,
        $localize`:@@primeng.month.sep:Settembre`,
        $localize`:@@primeng.month.oct:Ottobre`,
        $localize`:@@primeng.month.nov:Novembre`,
        $localize`:@@primeng.month.dec:Dicembre`,
      ],
      monthNamesShort: [
        $localize`:@@primeng.monthShort.jan:Gen`,
        $localize`:@@primeng.monthShort.feb:Feb`,
        $localize`:@@primeng.monthShort.mar:Mar`,
        $localize`:@@primeng.monthShort.apr:Apr`,
        $localize`:@@primeng.monthShort.may:Mag`,
        $localize`:@@primeng.monthShort.jun:Giu`,
        $localize`:@@primeng.monthShort.jul:Lug`,
        $localize`:@@primeng.monthShort.aug:Ago`,
        $localize`:@@primeng.monthShort.sep:Set`,
        $localize`:@@primeng.monthShort.oct:Ott`,
        $localize`:@@primeng.monthShort.nov:Nov`,
        $localize`:@@primeng.monthShort.dec:Dic`,
      ],
      today: $localize`:@@primeng.today:Oggi`,
      weekHeader: $localize`:@@primeng.weekHeader:Sett`,
      firstDayOfWeek: 1, // Lunedì
      dateFormat: $localize`:@@primeng.dateFormat:dd/mm/yy`,

      // --- Navigazione Calendario ---
      chooseYear: $localize`:@@primeng.chooseYear:Scegli Anno`,
      chooseMonth: $localize`:@@primeng.chooseMonth:Scegli Mese`,
      chooseDate: $localize`:@@primeng.chooseDate:Scegli Data`,
      prevDecade: $localize`:@@primeng.prevDecade:Decennio Precedente`,
      nextDecade: $localize`:@@primeng.nextDecade:Decennio Successivo`,
      prevYear: $localize`:@@primeng.prevYear:Anno Precedente`,
      nextYear: $localize`:@@primeng.nextYear:Anno Successivo`,
      prevMonth: $localize`:@@primeng.prevMonth:Mese Precedente`,
      nextMonth: $localize`:@@primeng.nextMonth:Mese Successivo`,
      prevHour: $localize`:@@primeng.prevHour:Ora Precedente`,
      nextHour: $localize`:@@primeng.nextHour:Ora Successiva`,
      prevMinute: $localize`:@@primeng.prevMinute:Minuto Precedente`,
      nextMinute: $localize`:@@primeng.nextMinute:Minuto Successivo`,
      prevSecond: $localize`:@@primeng.prevSecond:Secondo Precedente`,
      nextSecond: $localize`:@@primeng.nextSecond:Secondo Successivo`,
      am: $localize`:@@primeng.am:am`,
      pm: $localize`:@@primeng.pm:pm`,

      // --- Password ---
      weak: $localize`:@@primeng.password.weak:Debole`,
      medium: $localize`:@@primeng.password.medium:Media`,
      strong: $localize`:@@primeng.password.strong:Forte`,
      passwordPrompt: $localize`:@@primeng.password.prompt:Inserisci una password`,

      // --- Messaggi di Selezione e Filtro ---
      emptyFilterMessage: $localize`:@@primeng.emptyFilterMessage:Nessuna corrispondenza trovata`,
      searchMessage: $localize`:@@primeng.searchMessage:{0} risultati disponibili`,
      selectionMessage: $localize`:@@primeng.selectionMessage:{0} elementi selezionati`,
      emptySelectionMessage: $localize`:@@primeng.emptySelectionMessage:Nessun elemento selezionato`,
      emptySearchMessage: $localize`:@@primeng.emptySearchMessage:Nessun risultato trovato`,
      emptyMessage: $localize`:@@primeng.emptyMessage:Nessuna opzione disponibile`,

      // --- Operatori di Filtro ---
      startsWith: $localize`:@@primeng.filter.startsWith:Inizia con`,
      contains: $localize`:@@primeng.filter.contains:Contiene`,
      notContains: $localize`:@@primeng.filter.notContains:Non contiene`,
      endsWith: $localize`:@@primeng.filter.endsWith:Finisce con`,
      equals: $localize`:@@primeng.filter.equals:Uguale a`,
      notEquals: $localize`:@@primeng.filter.notEquals:Diverso da`,
      noFilter: $localize`:@@primeng.filter.noFilter:Senza Filtro`,
      lt: $localize`:@@primeng.filter.lt:Minore di`,
      lte: $localize`:@@primeng.filter.lte:Minore o uguale a`,
      gt: $localize`:@@primeng.filter.gt:Maggiore di`,
      gte: $localize`:@@primeng.filter.gte:Maggiore o uguale a`,
      dateIs: $localize`:@@primeng.filter.dateIs:Data è`,
      dateIsNot: $localize`:@@primeng.filter.dateIsNot:Data non è`,
      dateBefore: $localize`:@@primeng.filter.dateBefore:Data prima di`,
      dateAfter: $localize`:@@primeng.filter.dateAfter:Data dopo di`,
      clear: $localize`:@@primeng.filter.clear:Pulisci`,
      apply: $localize`:@@primeng.filter.apply:Applica`,
      matchAll: $localize`:@@primeng.filter.matchAll:Corrisponde a Tutti`,
      matchAny: $localize`:@@primeng.filter.matchAny:Corrisponde a Uno`,
      addRule: $localize`:@@primeng.filter.addRule:Aggiungi Regola`,
      removeRule: $localize`:@@primeng.filter.removeRule:Rimuovi Regola`,

      // --- Bottoni Generali e Dialog ---
      accept: $localize`:@@primeng.accept:Sì`,
      reject: $localize`:@@primeng.reject:No`,
      choose: $localize`:@@primeng.choose:Scegli`,
      upload: $localize`:@@primeng.upload:Carica`,
      cancel: $localize`:@@primeng.cancel:Annulla`,

      // --- Stati File/Processi ---
      completed: $localize`:@@primeng.completed:Completato`,
      pending: $localize`:@@primeng.pending:In attesa`,
    });
  }
}
